import { render, staticRenderFns } from "./DashboardInfoBlock.vue?vue&type=template&id=a94459e2&"
import script from "./DashboardInfoBlock.vue?vue&type=script&lang=js&"
export * from "./DashboardInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports